<!-- install banner temporary disabled
<div class="install_banner" *ngIf='showBanner'>
	<ng-container *ngIf='appService.Logo'>
		<img [src]="appService.getBaseServerAddress() + '/document_files/download/' + appService.Logo" class="icon" />
	</ng-container>

	Aggiungi l'applicazione sul tuo dispositivo per avere una migliore esperienza d'uso 
	<a class="add_to_home" (click)='onInstallBtnClick()'>Aggiungi a schermata Home</a>
	<i class="fa fa-times" (click)='closeBanner()'></i>
</div>-->

<!-- loader before domain loaded -->
<div class="app-overlay" *ngIf='isLoading || !appService.appData.value'>
	<loader></loader>
</div>

<ng-container *ngIf='!isLoading && appService.appData.value'>
	<!-- internal loader -->
	<loader *ngIf='appService.languageChanging.value'></loader>
	<!-- custom header -->
	<custom-header></custom-header>
	<!-- router outlet -->
	<div [ngClass]="{'custom-container': true, 'switch-language-loader': appService.languageChanging.value}" id="container">
		<router-outlet></router-outlet>
	</div>
	<!-- footer -->
	<custom-footer></custom-footer>
</ng-container>

<snackbar></snackbar>